import {$, _, Foundation, Radio} from '../../../vendor'
import { Biscuit } from '../../utils'
import InboomaSelectBox from '../../utils/InboomaSelectBox'
import InboomaBaseView from '../InboomaBaseView'

import SidebarFilterBehavior from '../../behaviors/Behavior.SidebarFilter'

import ContingentsSidebarTpl from '../../templates/contingents/ContingentsSidebarTpl.html'
import {getApiHost} from "../../Sync";
import * as FileSaver from "../../../vendor/FileSaver";

export default InboomaBaseView.extend({

    template : ContingentsSidebarTpl,
    el : '#inb-c-sidebar',

    templateContext () {
        return {
            _,
            resourcetypes : this._resourcetypesInUse,
            client_id: Biscuit.get('user.client_id')
        }
    },

    ui : {
        flistResourcetypes : '#inb-c-left-bar-flist--resourcetypes',
        flistLocations : '#inb-c-left-bar-flist--locations',
        flistLocationsInput : '#inb-c-left-bar-flist--locations__input',
        addContingent : '#inb-c-left-bar-add-contingent',
        dropdown : '.inb-dropdown',
    },

    events : {
        'click .inb-toggle-sidebar-dd' : '_initDropdown',
        'click #export-xls-contingents': '_export_contingents',
        'click #export-xls-resources': '_export_resources'
    },

    behaviors : [
        {
            behaviorClass: SidebarFilterBehavior,
            filterMap: {
                resourcetype : (view, filterVal) => view.collection.filterResourcetype(filterVal),
                locations : (view, filterVal) => view.collection.filterLocation(filterVal) 
            },
            unselectAllFilter : (view) => {
                view._locationsFilterSelect._reset();
            }
        }
    ],

    /**
     * Restore all given/previous filters in view and collection
     */
    _restoreFilterSettings () {

        const that = this;

        _.each(this.collection.getFiltersWithValue(), (val, type) => {

            switch (type) {
                case 'resourcetype_id' :
                    that.$el.find(`#inb-c-left-bar-flist--resourcetypes li[data-inb-val="${val}"]`)
                            .trigger('click');
                    break;

                case 'location_id' :
                    const locations = Radio.channel('locations').request('get:data');
    
                    locations.fetchById(val, location => {
                        if (!location) return;
                        that._locationsFilterSelect.setValue(location.get('name'));
                        that._locationsFilterSelect.getOption('onSelectItem')(location);
                    });
                    break;
            }
        });

    },

    initialize () {

        const that = this,
                resourcetypes = Radio.channel('resourcetypes').request('get:data');

        // Display only active resourcetypes for filtering
        this._resourcetypesInUse = {};

        _.each(this.collection.models, (model) => {
            const rt = model.get('resourcetype_id');
            
            if (rt !== null && typeof that._resourcetypesInUse[rt] == 'undefined') {
                that._resourcetypesInUse[rt] = resourcetypes.get(rt);
            }
        });

        this.render();
        this._restoreFilterSettings();
    },

    onRender () {

        const that = this,
              locations = Radio.channel('locations').request('get:data');
        
        let managerHasLocations = Biscuit.get('user.user_locations');

        if (managerHasLocations !== '') {
            managerHasLocations = managerHasLocations.split(',');
        }

        // lazy-load locations select box
        this._locationsFilterSelect = new InboomaSelectBox({
            el: this.getUI('flistLocationsInput'),
            collection: locations,
            sortBy: 'name',
            placeholder: this.t('select_${a}',{a:this.t('location')}),
            openListOnClose: false,
            listItemContent: model => {
                /*if (managerHasLocations.length && !_.contains(managerHasLocations, model.get('id').toString())) {
                    return '';
                }*/
                return model.get('name');
            },
            onSearch: query => {
                locations._filterParams = { 'q' : query };
                locations._skipPagination = true;

                locations.fetchNextPage(_.noop);
            },
            onSelectItem: model => {
                that.collection.filterLocation(model.get('id'));
            },
            onReset: () => {
                that.collection.removeFilter('location_id');
            }
        });

    },

    _initDropdown (ev) {

        ev.preventDefault();

        if (typeof this._dropdown === 'undefined') {
            this._dropdown = new Foundation.Dropdown($('#inb-c-sidebar .inb-dropdown'));
        }

        this._dropdown.open();

        return false;
    },

    _export_contingents () {
        const that =this;
        let params = '', count=0;
        _.each(this.collection.getFiltersWithValue(), (val, type) => {
            if(count > 0){
                params += '&'+type+'='+val;
            }else{
                params += '?'+type+'='+val;
            }
        });
        const xmlHttp = new XMLHttpRequest();

        xmlHttp.open("GET", getApiHost() + '/contingents/export'+params, true);

        //  xmlHttp.setRequestHeader('Accept', 'application/json')
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'))
        xmlHttp.responseType = "blob";

        xmlHttp.onload = function() {


            const blob = new Blob([xmlHttp.response], { type: 'application/xls' });
            FileSaver.saveAs(blob, that.t("contingents") +' '+that.get_date()+".xlsx");

        };

        xmlHttp.send(null);


    },

    _export_resources () {
        const that =this;
        let params = '', count=0;
        _.each(this.collection.getFiltersWithValue(), (val, type) => {
            if(count > 0){
                params += '&'+type+'='+val;
            }else{
                params += '?'+type+'='+val;
            }
        });
        const xmlHttp = new XMLHttpRequest();

        xmlHttp.open("GET", getApiHost() + '/resources/export'+params, true);

        //  xmlHttp.setRequestHeader('Accept', 'application/json')
        xmlHttp.setRequestHeader('Authorization', 'Bearer ' + Biscuit.get('token'))
        xmlHttp.responseType = "blob";

        xmlHttp.onload = function() {


            const blob = new Blob([xmlHttp.response], { type: 'application/xls' });
            FileSaver.saveAs(blob, that.t("resources") +' '+that.get_date()+".xlsx");

        };

        xmlHttp.send(null);


    },
    get_date(date = null){
        let today = new Date();
        if(date !== null){
            today= new Date(date);
        }
        let day = today.getDate(); // Tag

        // Monatsangabe startet bei 0!
        let month = today.getMonth()+1; // Monat

        let year = today.getFullYear(); // Jahr
        if(day < 10) {
            day = '0'+ day;
        }
        if(month < 10) {
            month = '0'+ month;
        }
        today = day + '.' + month + '.' + year;

        return today;
    }

});